import React, { Fragment } from 'react';
import * as moment from 'moment';
import { Link, navigate } from '@reach/router';
import { Breadcrumb, Button, Col, Row, Layout } from '@nackle/paper';
const { Content, Header } = Layout;
// styles
import '../versions.less';

export default class VersionsList extends React.Component {
    static defaultProps = {
        list: []
    };
    constructor( props ) {
        super( props );
        props.getVersions( props.solutionId );
    }

    componentDidMount() {
        this.props.getVersions( this.props.solutionId );
    }
    createNewPrivacy = async () => {
        const solutionId = this.props.solutionId;
        const versionId = await this.props.createVersion( solutionId );
        navigate( `${ this.props.companyId }/version/${ versionId }` );
    };

    renderBreadcrumbs() {
        return (
            <Breadcrumb>
                <Breadcrumb.Item>
                    <span>{ `Solution - ${ this.props.name }` }</span>
                </Breadcrumb.Item>
            </Breadcrumb>
        );
    }

    render() {
        const { list, solutionId, enableActivateVersion } = this.props;
        return (
            <Fragment>
                <Header className="page-header">
                    <Row align="middle">
                        <Col flex={ 1 }>
                            { this.renderBreadcrumbs() }
                        </Col>
                        <Col>
                            <div className="section-controls">
                                <Button
                                    onClick={ this.createNewPrivacy }
                                    className="add-privacy-btn"
                                    type="primary"
                                >
                                    Add New Privacy Notice
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Header>
                <Content>
                    <div className="list">

                        <div className="list-header">
                            <Row className="list-row">
                                <Col span={ 4 } className="list-item dark">
                                    <span className="list-header-text">Version</span>
                                </Col>
                                <Col span={ 4 } className="list-item dark">
                                    <span className="list-header-text">Date Added</span>
                                </Col>
                                <Col span={ 4 } className="list-item dark">
                                    <span className="list-header-text">Locales</span>
                                </Col>
                                <Col span={ 4 } className="list-item dark">
                                    <span className="list-header-text">Description</span>
                                </Col>
                                <Col span={ 4 } className="list-item dark">
                                    <span className="list-header-text">Status</span>
                                </Col>
                                <Col span={ 4 } className="list-item dark">
                                    <span className="list-header-text">Date Activated</span>
                                </Col>
                            </Row>
                        </div>
                        <div className="list-rows">
                            { list.map( version => (
                                <VersionListItem
                                    key={ `${ solutionId }-${ version.version }` }
                                    version={ version }
                                    getVersions={ this.props.getVersions }
                                    solutionId={ solutionId }
                                    activateVersion={ this.props.activateVersion }
                                    enableActivateVersion={ enableActivateVersion }
                                />
                            ) ) }
                        </div>
                    </div>
                </Content>
            </Fragment>
        );
    }
}

class VersionListItem extends React.Component {
    activateVersion = () =>
        this.props.activateVersion( this.props.version.id, this.props.solutionId );
    render() {
        const { version, enableActivateVersion } = this.props;
        return (
            <Row className="list-row">
                <Col span={ 4 } className="list-item">
                    <Link className="list-item-link" to={ `version/${ version.id }` }>
                        <span className="list-row-text">{ version.version }</span>
                    </Link>
                </Col>
                <Col span={ 4 } className="list-item">
                    <span className="list-row-text">
                        { moment( version.dateAdded ).format( 'MM/DD/YYYY' ) }
                    </span>
                </Col>
                <Col span={ 4 } className="list-item">
                    <span className="list-row-text">
                        { version.locales.map(
                            ( locales, i ) =>
                                `${ locales }${ version.locales.length !== i + 1 ? ', ' : '' }`
                        ) }
                    </span>
                </Col>
                <Col span={ 4 } className="list-item">
                    <span className="list-row-text">{ version.description }</span>
                </Col>
                <Col span={ 4 } className="list-item">
                    <Row>
                        <Col span={ 12 }>
                            <span className="list-row-text">{ version.status }</span>
                        </Col>
                        <Col span={ 12 }>
                            <span className="list-row-text">
                                { version.status === 'Saved' && (
                                    <Button
                                        className="activate-version"
                                        onClick={ this.activateVersion }
                                        disabled={ !enableActivateVersion }
                                        size="small"
                                    >
                                        Activate
                                    </Button>
                                ) }
                            </span>
                        </Col>
                    </Row>
                </Col>
                <Col span={ 4 } className="list-item">
                    <span className="list-row-text">
                        { !!version.dateActivated &&
                            moment( version.dateActivated ).format( 'MM/DD/YYYY' ) }
                    </span>
                </Col>
            </Row>
        );
    }
}
